(function() {
  var paymentGatewayForm = document.querySelector("[data-payment-gateway='form']");
  if (paymentGatewayForm) {
    paymentGatewayForm.addEventListener("onpaymentgatewayerror", function (data) {
      analytics.track("Payment Gateway Form Error", data.detail);
      document.querySelector(".checkout__cta").disabled = false;
    });
  }
})();
